import { render, staticRenderFns } from "./PatReception.vue?vue&type=template&id=18dd0a3f&scoped=true"
import script from "./PatReception.vue?vue&type=script&lang=js"
export * from "./PatReception.vue?vue&type=script&lang=js"
import style0 from "./PatReception.vue?vue&type=style&index=0&id=18dd0a3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dd0a3f",
  null
  
)

export default component.exports